import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useLeaseSigningProvider } from '../../../hooks/useLeaseSigningProvider';
import PropertyService from '../../../services/propertyService';
import type { PropertyChangeHistoryLog } from '../types';

export const useFetchLatestChangeHistoryLog = (
  organizationId,
  propertyId,
  changeName,
  flag,
) => {
  const propertyService = useMemo(() => {
    return new PropertyService();
  }, []);
  return useQuery(
    [`LatestChangeHistoryLog-${changeName}`, propertyId],
    (): PropertyChangeHistoryLog =>
      propertyService.getLatestChangeHistoryLog(
        organizationId,
        propertyId,
        changeName,
      ),
    { enabled: flag, staleTime: 60000 },
  );
};

export const useBlueMoonRow = (organizationId, propertyId, flag) => {
  const { provider, isLoading } = useLeaseSigningProvider({
    organizationId,
    propertyId,
    enabled: Boolean(flag),
  });
  let status = 'unknown';
  if (provider === 'BLUEMOON') {
    status = 'on';
  } else if (provider === 'FORTRESS') {
    status = 'off';
  }
  return { status, isLoading };
};
